module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/alert-triangle-purple-4dab9c478948e1e0bc21032b7fb27ae0.svg";